import _ from 'underscore';
import { BaseFilterAgent } from './base-filter-agent';

/**
 * Manage the creation/removal and show/hide of Searchbox Filter view<br>
 * Call FilterService to change filter state<br>
 * @extends BaseFilterAgent
 */
export class SearchboxFilterAgent extends BaseFilterAgent {
  constructor(options) {
    super(options);
    const newItem = {
      id: 'search-box-filter',
      onChange: this.apply.bind(this),
      placeholder: this.options.searchbox.placeholder,
      maxLength: this.options.searchbox.maxLength,
    };
    if (this.options.toolbarView.rendered) {
      this.options.toolbarView.view.update(newItem);
    } else {
      this.options.toolbarView.once('rendered', () => {
        this.options.toolbarView.view.update(newItem);
      });
    }
  }

  /**
   * Create FilterEntity based on search value and apply filter
   * @private
   * @param {string} value - Searchbox input
   * @returns {undefined}
   */
  apply(value) {
    if (value) {
      const query = _.object(
        [this.options.searchbox.searchProperty],
        [_.object([this.options.searchbox.searchOperator || '$contains'], [value])]
      );

      super.apply(query);
    }
  }

  /**
   * Clear search box
   * @returns {undefined}
   */
  clear() {
    this.options.toolbarView.view.update({
      id: 'search-box-filter',
      value: '',
    });
  }
}
